var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5473e9",
    fillRule: "evenodd",
    d: "M15.077 1.64V0C16.419 0 17.5 1.102 17.5 2.46v10.337h-1.62V2.461a.815.815 0 0 0-.81-.82.816.816 0 0 0-.81.82V21H0V2.46C0 1.102 1.087 0 2.43 0h12.647v1.64zm-2.438.82c0-.287.049-.563.138-.82H2.43a.814.814 0 0 0-.809.82v16.9H12.64V2.46zm-9.398.657h2.916v1.64H3.241v-1.64zm6.157 0h1.62v1.64h-1.62v-1.64zM3.241 6.398h7.778v1.64H3.24v-1.64zm0 3.281h7.778v1.64H3.24V9.68zm0 3.282h7.778v1.64H3.24v-1.64zm0 3.28h7.778v1.641H3.24v-1.64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.56bb6647c1bda373d22b46521a39c2ee.svg";
export { ForwardRef as ReactComponent };